<syrf-dialog-layout>
  <mat-form-field>
    <input matInput [formControl]="valueControl" />
  </mat-form-field>
  <h2>Base64 Decoded Guid: {{ guidValue$ | async }}</h2>
  <h2>Base64 Encoded Guid: {{ base64Value$ | async }}</h2>
</syrf-dialog-layout>
